// extracted by mini-css-extract-plugin
module.exports = {"loadingOverlay":"loading-overlay-module__loadingOverlay___swbQ_","loading":"loading-overlay-module__loading___1XvrK"};